import Vue from 'vue';
import PlayVideo from '../../video/components/play-video';

export default Vue.extend({
    components: {
        PlayVideo
    },

    data() {
        return {
            showPreview: false,
            loading: false,
            loadedVideos: {},
            currentVideo: null
        };
    },

    methods: {
        hideVideo() {
            this.showPreview = false;
            $('body').removeClass('overflow-hidden');
            $('#scrollTop').show();
            this.loading = false;
            this.currentVideo = null;
        },
        showVideo(url) {
            this.showPreview = true;
            $('body').addClass('overflow-hidden');
            $('#scrollTop').hide();

            if (typeof this.loadedVideos[url] !== 'undefined') {
                return this.currentVideo = this.loadedVideos[url];
            }

            this.loading = true;

            this.getRequest(url)
                .then(data => {
                    if (data.results && data.results.title) {
                        this.loadedVideos[url] = data.results.title;
                        this.currentVideo = data.results.title;
                    } else {
                        this.loadedVideos[url] = null;
                        this.currentVideo = null;
                    }
                })
                .catch(error => {
                    this.loadedVideos[url] = null;
                    this.currentVideo = null;
                })
                .finally(() => this.loading = false);
        },
    },
});